import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
    pageContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100vh',
      paddingBottom: '10vh',
    },
    title: {
      fontFamily: 'lato-hairline',
      fontSize: '60px',
      paddingBottom: '5vh',
      textTransform: 'uppercase',
    },
    message: {
      fontSize: '16px',
    },
  }),
);

export default useStyles;
